/**
 * Production Time Validator
 * Prevents checkout when cart items have mismatched production time selections.
 * Works on both the cart page and cart drawer.
 */
(function () {
  const PROPERTY_NAME = 'Production Time';
  const WARNING_ID = 'production-time-mismatch-warning';

  function getProductionTimes() {
    const items = document.querySelectorAll('.cart-item');
    const times = [];

    items.forEach((item) => {
      const properties = item.querySelectorAll('.line-item-property');
      properties.forEach((prop) => {
        const label = prop.querySelector('.line-item-property__label');
        const value = prop.querySelector('.line-item-property__value');
        if (label && value) {
          const labelText = label.textContent.replace(':', '').trim();
          if (labelText === PROPERTY_NAME) {
            times.push(value.textContent.trim());
          }
        }
      });
    });

    return times;
  }

  function hasMismatch(times) {
    if (times.length <= 1) return false;
    return new Set(times).size > 1;
  }

  function createWarningBanner() {
    const banner = document.createElement('div');
    banner.id = WARNING_ID;
    banner.setAttribute('role', 'alert');
    banner.style.cssText =
      'background:#fef3cd;border:1px solid #ffc107;color:#856404;padding:12px 16px;margin:12px 0;border-radius:6px;font-size:14px;line-height:1.5;text-align:center;';
    banner.innerHTML =
      '<strong>Production Time Mismatch</strong><br>' +
      'All items in your order must have the same production time. ' +
      'Please update your items so they all match before checking out.';
    return banner;
  }

  function setCheckoutDisabled(container, disabled) {
    // Cart page checkout button
    const cartPageBtn = container.querySelector('#update-cart[name="checkout"]');
    if (cartPageBtn) {
      cartPageBtn.disabled = disabled;
      cartPageBtn.style.opacity = disabled ? '0.5' : '';
      cartPageBtn.style.pointerEvents = disabled ? 'none' : '';
    }

    // Cart drawer checkout link (it's an <a> tag)
    const drawerBtns = container.querySelectorAll('.checkout-buttons .btn');
    drawerBtns.forEach((btn) => {
      if (disabled) {
        btn.dataset.originalHref = btn.getAttribute('href') || '';
        btn.removeAttribute('href');
        btn.style.opacity = '0.5';
        btn.style.pointerEvents = 'none';
        btn.setAttribute('aria-disabled', 'true');
      } else {
        if (btn.dataset.originalHref) {
          btn.setAttribute('href', btn.dataset.originalHref);
        }
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        btn.removeAttribute('aria-disabled');
      }
    });

    // Also block dynamic checkout buttons
    const additionalBtns = container.querySelector('.additional-checkout-buttons');
    if (additionalBtns) {
      additionalBtns.style.opacity = disabled ? '0.5' : '';
      additionalBtns.style.pointerEvents = disabled ? 'none' : '';
    }
  }

  function validate() {
    const times = getProductionTimes();
    const mismatch = hasMismatch(times);

    // Handle cart page
    const cartForm = document.querySelector('.cart-form');
    if (cartForm) {
      updateContainer(cartForm, mismatch);
    }

    // Handle cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      updateContainer(cartDrawer, mismatch);
    }
  }

  function updateContainer(container, mismatch) {
    let warning = container.querySelector('#' + WARNING_ID);

    if (mismatch) {
      if (!warning) {
        warning = createWarningBanner();
        // Insert before the checkout area
        const subtotalArea =
          container.querySelector('.checkout-subtotal-container') ||
          container.querySelector('.cart-drawer__footer');
        if (subtotalArea) {
          subtotalArea.insertBefore(warning, subtotalArea.firstChild);
        }
      }
      setCheckoutDisabled(container, true);
    } else {
      if (warning) {
        warning.remove();
      }
      setCheckoutDisabled(container, false);
    }
  }

  // Run on page load
  validate();

  // Re-validate when cart contents change (AJAX updates)
  // The theme fires 'on:cart:after-merge' after cart updates
  document.addEventListener('on:cart:after-merge', function () {
    // Small delay to let DOM update
    setTimeout(validate, 200);
  });

  // Also observe DOM changes as a fallback for cart drawer open/updates
  const observer = new MutationObserver(function (mutations) {
    let shouldValidate = false;
    for (const mutation of mutations) {
      if (
        mutation.target.classList &&
        (mutation.target.classList.contains('cart-item-list__body') ||
          mutation.target.classList.contains('cart-drawer__content'))
      ) {
        shouldValidate = true;
        break;
      }
      for (const node of mutation.addedNodes) {
        if (node.classList && node.classList.contains('cart-item')) {
          shouldValidate = true;
          break;
        }
      }
    }
    if (shouldValidate) {
      setTimeout(validate, 200);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
